<div
  class="hot-toast-error-icon"
  [style.--error-primary]="theme?.primary"
  [style.--error-secondary]="theme?.secondary"
></div>
